import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WBChildComment, WBParentComment } from '../models/workbook-comment.models';
import { WorkbookCommentService } from '../services/workbook-comment.services';
import { AppMainService } from 'src/app/app-main.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormBuilder } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { AppMainComponent } from 'src/app/app.main.component';
import "quill-mention/autoregister";
import { DynamicTableService } from 'src/app/modules/shared/services/dynamic-table/dynamic-table.service';
import { DomSanitizer } from '@angular/platform-browser';
import { validateFiles } from 'src/app/shared/upload-files';
import { DocumentManagementService } from 'src/app/modules/shared/services/document-management/document-management.service';
import { countPlainTextLength } from 'src/app/modules/shared/helpers/count-plaintext-length';

@Component({
  selector: 'app-workbook-comment-details',
  templateUrl: './workbook-comment-details.component.html',
  styleUrl: './workbook-comment-details.component.scss'
})
export class WorkbookCommentDetailsComponent {
@Input() wbParentComment: WBParentComment;
@Input() displayCommentDetailPopup: boolean = false;
@Input() workbookId: string;
@Input() rowNumber: number;
@Input() fromNotification: boolean = false;
@Output() hideCommentDetailsPopup = new EventEmitter();

/** Subscription and Cleanup */
protected ngUnsubscribe$: Subject<void> = new Subject<void>(); 

quillEditor: any;
isView = true;
isUpdateNote = false;
isUpdateNoteComment = false;
noteArea = true;
newComment = '';
noteComment = '';
selectedNoteComments;
isViewMode = false;

wbChildComments: WBChildComment[] = [];
workbookComments: WBParentComment[] = [];
displayFilePreview: boolean = false;
currentFile: any;
selectedUserId:any
attachments: any[] = [];
multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
<li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, csv, doc, docx, ppt, pptx are allowed</li>
<li>Each File size should not be more than 10MB</li>
<li>You can upload a maximum of 5 files at a time</li>
</ul>
`;

allowedExtensions = [
'pdf',
'csv',
'txt',
'xls',
'xlsx',
'doc',
'docx',
'png',
'jpg',
'jpeg',
'ppt',
'pptx',
'gif'
]; // For the attachment files

users: any[] = []; // The list of all users to filter from.
quillConfig={
  //toolbar: '.toolbar',
  toolbar: false,
  mention: {
    allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
    mentionDenotationChars: ["@", "#"],
    showDenotationChar: false,
    spaceAfterInsert: false,
    positioningStrategy: "fixed",
    source: (searchTerm, renderList, mentionChar) => {
      let values = mentionChar === "@" ? this.users : this.users;
  
      if (searchTerm.length === 0) {
        renderList(values, searchTerm);
      } else {
        const matches = values.filter(user =>
          user.value?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        renderList(matches, searchTerm);
      }
    },
  },
}

displayUserDetails: boolean = false;

//attachment object for lino attachment chips
  // logMap: { [key: string]: any } = {}; 
  logMap: { 
    [key: string]: { 
      log: { 
        logAttachments: any[] 
      } 
    } 
  } = {}; 
  attachmentsMap  = {}
  isUploading: boolean = false;
  countPlainTextLength=countPlainTextLength;

constructor(
  private app: AppMainComponent,
  public readonly workbookCommentService: WorkbookCommentService,
  private readonly appMainService: AppMainService,
  private readonly confirmationService: ConfirmationService,
  private readonly messageService: MessageService,
  private fb: FormBuilder,
  private dynamicTableService: DynamicTableService,
  private sanitizer: DomSanitizer,
  private readonly documentManagementService: DocumentManagementService,
) {
  const users = this.app.usersList;
  this.users = users.map(user => ({ id: user.id, value: user.name }));
 } 
ngOnInit(): void {
  if(this.fromNotification){
  this.getWBParentComment(this.rowNumber); //To verify parent comment is deleted or not. 
  }
  else{
    this.wbParentComment.viewContent = this.sanitizer.bypassSecurityTrustHtml(this.wbParentComment.content);
    this.getWBChildComment(this.rowNumber, this.wbParentComment.id);
  }
}

private clickHandler: (event: MouseEvent) => void;
ngAfterViewInit() {
  this.clickHandler = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const mentionElement = target.closest('.mention');
    if (mentionElement) {
      event.stopPropagation();
      const userId = mentionElement.getAttribute('data-id');
      if (this.selectedUserId && this.selectedUserId !== userId) {
        this.openTaggedUserDetails(userId);
      }
    }
  };

  document.addEventListener('click', this.clickHandler);
}



markAsReadChild(childComment: WBChildComment, event){
  event.stopPropagation();
  childComment.isRead=true;
}

markAsReadParent(wbParentComment, event)
{
  event.stopPropagation();
  if(wbParentComment.isRead===false){
    wbParentComment.isRead=true;
  }
}

updateChildCommentStatus(ParentCommentId: string) {
  const isRead: boolean = true;
  this.appMainService.isShowSpinner('updateChildCommentStatus');
  this.workbookCommentService.updateChildCommentStatus(this.workbookId, isRead, this.rowNumber, ParentCommentId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
    next: (response: any) => {
      this.appMainService.isHideSpinner('updateChildCommentStatus');
    },
    error: (error) => {
      this.appMainService.isHideSpinner('updateChildCommentStatus');
    }
  })
}

getWBParentComment(rowNumber) {
  this.appMainService.isShowSpinner('getWBParentComment');
  this.workbookCommentService.getWBParentComment(this.workbookId, rowNumber).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
    next: (response: any) => {
      this.appMainService.isHideSpinner('getWBParentComment');
      const wbParentComment = response.find(comment => comment.id === this.wbParentComment.id);
      if(wbParentComment){
        wbParentComment.viewContent = this.sanitizer.bypassSecurityTrustHtml(wbParentComment.content);
      }
      if (this.fromNotification) {
        if (wbParentComment) {
          this.wbParentComment.viewContent = wbParentComment.viewContent;
          this.wbParentComment.attachment = wbParentComment.attachment;
          this.getWBChildComment(rowNumber, wbParentComment.id);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Comment is deleted' });
          this.hideComment();
        }
      } else {
        this.wbParentComment = wbParentComment ? structuredClone(wbParentComment) : null;
        this.wbParentComment.viewContent = this.sanitizer.bypassSecurityTrustHtml(this.wbParentComment.content);
      }      
    },
    error: (error) => {
      this.appMainService.isHideSpinner('getWBParentComment');
    }
  })
}

getWBChildComment(rowNumber, parentId) {
  this.appMainService.isShowSpinner('getWBChildComment');
  this.workbookCommentService.getWBChildComment(this.workbookId, rowNumber, parentId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
    next: (response: any) => {
      this.appMainService.isHideSpinner('getWBChildComment');
      const responses= response.map(comment => (
        { ...comment, viewContent: this.sanitizer.bypassSecurityTrustHtml(comment.content), }));
      this.wbChildComments = responses;
      if (this.fromNotification &&(this.wbParentComment?.commentNotificationId !== this.wbParentComment?.id) && !this.wbChildComments.some(comment => comment.id === this.wbParentComment?.commentNotificationId)) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Comment is deleted' });
        this.hideComment();
      }      
      if(this.wbParentComment?.hasUnReadComments===true || this.wbParentComment?.isRead===false){
        this.wbParentComment.hasUnReadComments=false;
      this.updateChildCommentStatus(parentId)
      }
    },
    error: (error) => {
      this.appMainService.isHideSpinner('getWBChildComment');
    }
  })
}

deleteComment(selectedComments) {
  this.confirmationService.confirm({
    message: 'Do you want to delete this Comment?',
    header: 'Delete Confirmation',
    icon: 'pi pi-info-circle',
    key: 'deleteCommentDetails',
    accept: () => {
      this.appMainService.isShowSpinner('deleteComment');
      this.workbookCommentService.deleteWorkbookRowComment(this.workbookId, selectedComments.id, this.rowNumber).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
        next: (response: any) => {
          this.appMainService.isHideSpinner('deleteComment');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment deleted successfully!' });
          if( selectedComments.id === this.wbParentComment.id){
            this.hideComment();
          }
          else{
            this.getWBChildComment(this.rowNumber, this.wbParentComment.id);
          }
        },
        error: (error) => {
          this.appMainService.isHideSpinner('deleteComment');
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to delete comment!' });
        }
      })
    },
    reject: () => { },
  });

}

//#region SaveNoteComment
saveNoteComment(){
  if(this.newComment){
  const mentionUser = this.getMentions(this.newComment) || [];
  const mentionedUserIds: number[] = mentionUser.map(user => user.id) || [];

  const addChildCommentPayload: any = {
    tableId: this.workbookId,
    rowNumber: this.rowNumber,
    value: this.newComment,
    parentId: this.wbParentComment.id,
    mentionedUserIds: mentionedUserIds.length > 0 ? mentionedUserIds : [],
    attachment: []
  };

  // Append attachments
  const attachments:any = this.attachmentsMap['newChildAttachment'] || [];
  addChildCommentPayload.attachment = attachments.map(file => ({
    name: file.fileName,
    sizeInKB: file.fileSizeInKB,
    attachmentId: file.id,
  }));
    this.appMainService.isShowSpinner('saveNoteComment');
    this.workbookCommentService.createWorkbookRowComment(this.workbookId, addChildCommentPayload, this.rowNumber).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('saveNoteComment');
        this.wbParentComment.isRead=true;
        this.getWBChildComment(this.rowNumber, this.wbParentComment.id);
        this.newComment = '';
        // this.attachments = [];
        this.attachmentsMap['newChildAttachment'] = [];
        this.refreshCommentAttachemnt('newChildAttachment');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('saveNoteComment');
      }
    })
  } else {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter comment' });
  } 
} 

hideComment(){
  this.displayCommentDetailPopup = false;
  this.refreshCommentAttachemnt('newChildAttachment');
  this.hideCommentDetailsPopup.emit({ "displayCommentDetailPopup": this.displayCommentDetailPopup });
} 

showHideUpdateNoteComment(data, fieldId) {
  this.selectedNoteComments = data;
  this.isUpdateNoteComment = true;
  this.noteArea = false;

  if (data.content) {
      this.noteComment = data.content;
  }
    // Check if attachment exists in data and update logMap accordingly
    if (data?.attachment && fieldId)
    {
      this.patchAttachments(data.attachment, fieldId);
    }
}

showHideUpdateNote(data, fieldId) {

  if (data.content) {
    this.noteComment = data.content;
}
  this.isUpdateNote = true;
  this.noteArea = false;
    // Check if attachment exists in data and update logMap accordingly
    if (data?.attachment && fieldId)
      {
        this.patchAttachments(data.attachment, fieldId);
      }
}

patchAttachments(attachments: any[], fieldId: string) {
  if (!this.logMap[fieldId]) {
    this.logMap[fieldId] = { log: { logAttachments: [] } };
  }

  if (!this.attachmentsMap) {
    this.attachmentsMap = {};
  }

  if (!this.attachmentsMap[fieldId]) {
    this.attachmentsMap[fieldId] = [];
  }
  const logAttachments = attachments.map((file) => {
    return {
      id: 0,
      createdSource: this.app.userIP,
      createdBy: this.app.user.userId,
      createdDate: new Date(),
      logId: 0,
      attachmentId: file.attachmentId,
      attachment: {
        id: file.attachmentId,
        content: null,
        name: file?.name,
        extension: file?.extension || null, // Ensure extension is updated if required
        isValid: true,
        sizeInBytes: file?.fileSizeInKB || null,
        statusId: 1,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        createdSource: this.app.userIP,
        location: file?.location || null,
      },
    };
  });

  // Update logMap for the given fieldId
  this.logMap[fieldId].log.logAttachments = logAttachments;

  // Update attachmentsMap separately for the given fieldId
  this.attachmentsMap[fieldId] = attachments.map(file => ({
    id: file.attachmentId,
    fileName: file.name,
    extension: file?.extension || null,
    fileSizeInKB: file?.fileSizeInKB,
    location: file?.location
  }));
}


updateNoteComment() {
  if(this.noteComment){
    const mentionUser = this.getMentions(this.noteComment) || [];
    const mentionedUserIds:number[] = mentionUser.map(user => user.id) || [];
  const updateCommentPayload = {
    commentId: this.selectedNoteComments.id,
    value: this.noteComment,
    mentionedUserIds: mentionedUserIds,
    attachments: []
  }
  // Append attachments
  const attachments:any = this.attachmentsMap['editChildComment'] || [];
  updateCommentPayload.attachments = attachments.map(file => ({
    name: file.fileName,
    sizeInKB: file.fileSizeInKB,
    attachmentId: file.id,
  }));
  this.appMainService.isShowSpinner('updateNoteComment');
  this.workbookCommentService.updateWorkbookRowComment(this.workbookId, updateCommentPayload, this.rowNumber).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
    next: (response: any) => {
      this.appMainService.isHideSpinner('updateNoteComment');
      this.wbParentComment.isRead=true;
      this.getWBChildComment(this.rowNumber, this.wbParentComment.id);
      this.noteComment = '';
      this.attachmentsMap['editChildComment'] = [];
      this.refreshCommentAttachemnt('editChildComment');
      this.isUpdateNoteComment = false;
      this.noteArea = true;
    },
    error: (error) => {
      this.appMainService.isHideSpinner('updateNoteComment');
    }
  })
} else {
  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter comment' });     
}
}

updateNote() {
  if(this.noteComment){
    const mentionUser = this.getMentions(this.noteComment) || [];
    const mentionedUserIds:number[] = mentionUser.map(user => user.id) || [];
  const updateCommentPayload = {
    commentId: this.wbParentComment.id,
    value: this.noteComment,
    mentionedUserIds: mentionedUserIds,
    attachments: []
  }
    // Append attachments
    const attachments:any = this.attachmentsMap['editParentComment'] || [];
    updateCommentPayload.attachments = attachments.map(file => ({
      name: file.fileName,
      sizeInKB: file.fileSizeInKB,
      attachmentId: file.id,
    }));
  this.appMainService.isShowSpinner('updateNote');
  this.workbookCommentService.updateWorkbookRowComment(this.workbookId, updateCommentPayload, this.rowNumber).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
    next: (response: any) => {
      this.appMainService.isHideSpinner('updateNote');
      this.attachmentsMap['editParentComment'] = [];
      this.refreshCommentAttachemnt('editParentComment');
      this.getWBParentComment(this.rowNumber);
      this.noteComment = '';
      this.isUpdateNote = false;
      this.noteArea = true;
    },
    error: (error) => {
      this.appMainService.isHideSpinner('updateNote');
    }
  })
} else {
  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter comment' });     
}   
}



getMentions(comment: string) {
  const mentionRegex = /<span class="mention"[^>]*data-id="(.*?)"[^>]*data-value="(.*?)"[^>]*>/g;
  let mentions: { id: number; name: string }[] = [];
  let uniqueMentionsMap = new Map<number, { id: number; name: string }>(); // Map to store unique mentions by id
  let match;

  while ((match = mentionRegex.exec(comment)) !== null) {
    const id = parseInt(match[1], 10); // Convert id to number
    const name = match[2]; // Extracted mention name

    // Add to the Map to ensure uniqueness based on id
    uniqueMentionsMap.set(id, { id, name });
  }

  mentions = Array.from(uniqueMentionsMap.values());

  return mentions;
}


  deleteAttachment(attachment, commentId) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this attachment?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      key: 'deleteCommentDetails',
      accept: () => {
        this.appMainService.isShowSpinner('deleteAttachment');
        this.workbookCommentService.deleteWBRowCommentAttachment(attachment.attachmentId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
          next: (response: any) => {
            this.appMainService.isHideSpinner('deleteAttachment');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Attachment deleted successfully!' });
            if( commentId === this.wbParentComment.id){
              this.getWBParentComment(this.rowNumber);
            }
            else{
              this.getWBChildComment(this.rowNumber, this.wbParentComment.id);
            }
          },
          error: (error) => {
            this.appMainService.isHideSpinner('deleteAttachment');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to delete attachment!' });
          }
        })
      },
      reject: () => { },
    });
  } 

  previewFile(data) {
    this.appMainService.isShowSpinner('previewFile');
    this.dynamicTableService.downloadDocument(this.workbookId, this.rowNumber, data.attachmentId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('previewFile');
        const fileUrl = response?.downloadLink; // Replace with your API's file URL field
        if (fileUrl) {
          this.currentFile = response;
          const extension = data?.extension?.replace('.', '').replace(/\s+/g, '') || '';
          this.currentFile.extension = extension
          this.displayFilePreview = true;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
        }
      },
      error: (error) => {
        this.appMainService.isHideSpinner('previewFile');
        this.displayFilePreview = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
      }
    })
  }
  openFilePreview(event, data) {
    event.stopPropagation();
    this.previewFile(data);
  }
  closeFilePreview() {
    this.currentFile = null;
    this.displayFilePreview = false;
    this.currentFile = null;
  }
  uploadAttachments(event: any, fileUpload: any, fieldId: string) {
    if (event?.files && event?.files.length > 5) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Maximum 5 files are allowed at once!'
      });
      fileUpload.clear();
      return;
    }
  
    let errors = [];
    for (let file of event.files) {
      this.appMainService.isShowSpinner('upload');  
      errors = validateFiles(file, 10, this.allowedExtensions);
      if (errors.length) {
        for (let error of errors) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${error.fileName}: ${error.error}`
          });
        }
        this.appMainService.isHideSpinner('upload');
      }
      this.appMainService.isHideSpinner('upload');
    }
  
    if (errors.length) {
      fileUpload.clear();
      return;
    }
  
    const uploadedFiles: File[] = Array.from(event.files || []);
    if (!Array.isArray(uploadedFiles)) {
      return;
    }
    const path = `workbook/${this.workbookId}/row-${this.rowNumber}/comment`;
    fileUpload.clear()
    // Open modal for file upload confirmation
    this.bulkUploadDocument(uploadedFiles, path, fieldId);
  }

  bulkUploadDocument(files: File[], path: string, fieldId) {
    this.isUploading = true; // Disable the button
    this.appMainService.isShowSpinner('bulkUpload');
    this.documentManagementService.bulkUploadDocument(files, path)
  .pipe(takeUntil(this.ngUnsubscribe$))
  .subscribe({
    next: (response: any) => {
      this.appMainService.isHideSpinner('bulkUpload');
      this.isUploading = false; // Disable the button
      if (response) {
        this.updateFormWithFiles(response, fieldId);
      }
    },
    error: (error) => {
      this.appMainService.isHideSpinner('bulkUpload');
      this.isUploading = false; // Disable the button
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to upload documents!' });
    }
  });
  } 

  updateFormWithFiles(files: any[], fieldId: string) {  
    if (!this.logMap[fieldId]) {
      this.logMap[fieldId] = { log: { logAttachments: [] } };
    }
    files.forEach(file => {
      if (file !== null && file !== undefined) {
        // formArray.push(new FormControl(file));
        const attachmentData = {
          id: file.id,
          content: null, 
          name: file?.fileName,
          extension: null, // Need to be updated if required
          isValid: true,
          sizeInBytes: file.fileSizeInKB,
          statusId: 1,
          createdBy: this.app.user.userId,
          createdDate: new Date(),
          createdSource: this.app.userIP,
          location: file.location,
        };
  
        const logAttachmentData = {
          id: 0,
          createdSource: this.app.userIP,
          createdBy: this.app.user.userId,
          createdDate: new Date(),
          logId: 0,
          attachmentId: file.id,
          attachment: attachmentData
        };
        this.logMap[fieldId].log.logAttachments.push(
          this.app.copyObjectWithoutRefrence(
            logAttachmentData
          )
        );
         // Store files based on `fieldId`
      if (!this.attachmentsMap) {
        this.attachmentsMap = {};  // Initialize if not exists
      }

      if (!this.attachmentsMap[fieldId]) {
        this.attachmentsMap[fieldId] = [];
      }
      this.attachmentsMap[fieldId].push(file);
        // this.attachments.push(file);
      }
    });
}

  removeAttachment(attachments: any[], fieldId: string) {
    if (this.attachmentsMap[fieldId] && this.attachmentsMap[fieldId].length > 0 ) {
      const index = attachments.findIndex(obj => obj?.attachment?.statusId === 3);
      if (index !== -1) {
        this.attachmentsMap[fieldId].splice(index, 1);
      }
    }
  }
   
  //#region Tagged User Details Popup
    openTaggedUserDetails(userId: any) {
      if (this.selectedUserId === userId && this.displayUserDetails) {
        // If clicking the same user, do nothing
        return;
      }
      this.selectedUserId = userId;
      this.displayUserDetails = true;
    }

    closeTaggedUserDetails(){
      this.selectedUserId = null;
      this.displayUserDetails = false;
    }
  //#endregion Tagged User Details Popup 
  refreshCommentAttachemnt(fieldId: string) {
    if (this.logMap[fieldId]) {
      this.logMap[fieldId].log.logAttachments = []; // Reset only specific logAttachments
    }
  }  
    ngOnDestroy() {
      document.removeEventListener('click', this.clickHandler);
      if (this.ngUnsubscribe$) {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
        this.ngUnsubscribe$.unsubscribe();
      }
    }
}
